import { createEffect, onCleanup } from "solid-js";
function createEffectWithCleaning(effect) {
    let lastCleanup;
    onCleanup(() => lastCleanup?.());
    createEffect((prevCleanup) => {
        if (prevCleanup) {
            lastCleanup = undefined;
            prevCleanup?.();
        }
        return (lastCleanup = effect());
    });
}
export default createEffectWithCleaning;
